<template>
	<v-app>
		<v-main>
			<v-container class="fill-height" fluid>
				<div class="background-image"></div>
				<v-row justify="center" align="center">
					<v-col cols="12" sm="8" md="6" lg="4">
						<v-card elevation="12" class="pa-6 rounded-lg">

							<v-card-title class="text-h4 justify-center primary--text mb-6">
								🚀 海鸥用户注册
							</v-card-title>

							<v-card-text>
								<!-- 邀请码 -->
								<v-text-field label="邀请码" v-model.trim="loginForm.invitationCode"
									prepend-icon="mdi-account-key" outlined dense class="mb-4"></v-text-field>

								<!-- 用户名 & 密码 -->
								<v-row>
									<v-col cols="12" md="6">
										<v-text-field label="用户名" v-model.trim="loginForm.loginName"
											prepend-icon="mdi-account" outlined dense
											:rules="[v => !!v || '用户名不能为空',v => v.length >= 4 || '用户名至少4个字符']"></v-text-field>
									</v-col>
									<v-col cols="12" md="6">
										<v-text-field label="密码" v-model.trim="loginForm.password"
											prepend-icon="mdi-lock" :type="showPassword ? 'text' : 'password'" outlined
											dense :append-icon="showPassword ? 'mdi-eye-off' : 'mdi-eye'"
											@click:append="showPassword = !showPassword" :rules="[v => !!v || '密码不能为空',
				v => v.length >= 6 || '密码至少6个字符']"></v-text-field>
									</v-col>
								</v-row>

								<!-- 手机验证 -->
								<v-row class="mt-2">
									<v-col cols="12" sm="8">
										<v-text-field v-model.trim="loginForm.mobile" label="手机号码"
											prepend-icon="mdi-cellphone" outlined dense :rules="[
                      v => !!v || '手机号不能为空',
                      v => /^1[3-9]\d{9}$/.test(v) || '手机号格式不正确'
                    ]"></v-text-field>
									</v-col>
									<!-- <v-col cols="12" sm="4">
										<v-btn color="secondary" block :disabled="!loginForm.mobile"
											@click="getCaptcha">
											获取验证码
										</v-btn>
									</v-col> -->
								</v-row>

								<!-- 验证码 -->
								<!-- <v-text-field v-model.trim="loginForm.captcha" label="短信验证码"
									prepend-icon="mdi-message-text" outlined dense class="mt-4"
									:rules="[v => !!v || '验证码不能为空']"></v-text-field> -->

								<!-- 提示信息 -->
								<v-alert v-if="msg" :type="msgType" dense class="mt-2">
									{{ msg }}
								</v-alert>
							</v-card-text>

							<v-card-actions>
								<v-btn color="primary" block large @click="register" :loading="loading">
									立即注册
									<template v-slot:loader>
										<v-progress-circular indeterminate size="24"></v-progress-circular>
									</template>
								</v-btn>
							</v-card-actions>
						</v-card>
					</v-col>
				</v-row>
			</v-container>
		</v-main>
	</v-app>
</template>

<script>
	export default {
		data() {
			return {
				loginForm: {
					captchaKey: null,
					mobile: null,
					invitationCode: null,
					loginName: null,
					password: null,
					captcha: null
				},
				showPassword: false,
				msg: null,
				loading: false
			};
		},
		created() {
			this.createClouds();
		},
		methods: {
			async getCaptcha() {
				if (this.loginForm.mobile == "") {
					this.msg = "请输入电话号码";
				} else {
					if (this.sendMsg) {
						this.loginForm.captchaKey = "kt" + new Date().getTime();
						let obj = {
							captchaKey: this.loginForm.captchaKey,
							tel: this.loginForm.mobile
						}
						let result = await this.$axios.post(this.$serverUrl + "/getCaptcha", obj);
						if (result.data.success == true) {
							this.sendMsg = false;
							let timer = setInterval(() => {
								this.time -= 1;
								if (this.time <= 0) {
									clearInterval((timer));
									this.sendMsg = true;
									this.time = 60
								}
							}, 1000);
						}
					}
				}
			},

			async register() {
				this.msg = "";
				let res = await this.$axios.post("/kt-supplier/user/register", this.loginForm);

				if (res.data.state === 200) {
					this.msg = "注册成功，请登录";
					this.$router.push('/');
				} else {
					if (res.data.state == 500) {
						this.msg = res.data.msg;
					}
				}
			},
		},
	};
</script>

<style>
	.background-image {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background-size: contain;
		background-repeat: no-repeat;
		background-position: left;
		pointer-events: none;
		background-image: url(./../assets/seagull-bg.png);
		background-color: #00599b;
		opacity: 0.6
	}
</style>